import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Renders children in a fixed layer under `anchor`, outside any clipping
 * container (grid toolbars paint with overflow clipped). Without `width` the
 * layer is exactly as wide as the anchor.
 */
export default function FloatingDropdown({ anchor, width, children }: {
  anchor: React.RefObject<HTMLElement>;
  width?: number;
  children: React.ReactNode;
}) {
  const [box, setBox] = useState<{ top: number; left: number; width: number } | null>(null);
  useLayoutEffect(() => {
    const place = () => {
      const el = anchor.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      const w = width === undefined ? r.width : Math.max(Math.min(width, window.innerWidth - r.left - 16), r.width);
      setBox({ top: r.bottom + 4, left: r.left, width: w });
    };
    place();
    window.addEventListener('resize', place);
    window.addEventListener('scroll', place, true);
    return () => {
      window.removeEventListener('resize', place);
      window.removeEventListener('scroll', place, true);
    };
  }, [anchor, width]);
  if (!box) return null;
  return createPortal(
    <div className="smart-floating" style={{ top: box.top, left: box.left, width: box.width }}>{children}</div>,
    document.body,
  );
}
